import { ItemTypeConsts } from 'client/util/Constants';
import CommandQueueDetailMainPanel from 'client/Commands/CommandQueueDetailMainPanel';

const CommandAsidePanel = () => import('client/Commands/CommandAsidePanel.vue');
const CommandsResultsMainPanel = () => import('client/Commands/CommandsResultsMainPanel.vue');

const commandsProps = {
  asidePanel: {
    isExpanded: true,
    itemType: ItemTypeConsts.command,
  },
  mainPanel: {
    gettingStartedPanelItemType: ItemTypeConsts.command,
    isAsideOpen: false,
    itemType: ItemTypeConsts.command,
    selectedModelId: '',
    setSelectedModelId(selectedModelId) {
      this.selectedModelId = selectedModelId;
    },
  },
};

const metaData = {
  title: 'Commands',
};

export default [
  {
    path: '/commands',
    meta: metaData,
    components: {
      mainPanel: CommandsResultsMainPanel,
    },
    props: {
      mainPanel: commandsProps.mainPanel,
    },
  },
  {
    path: '/commands/new',
    meta: metaData,
    components: {
      mainPanel: CommandsResultsMainPanel,
      asidePanel: CommandAsidePanel,
    },
    props: {
      mainPanel: commandsProps.mainPanel,
      asidePanel: commandsProps.asidePanel,
    },
  },
  {
    path: '/commands/registrationtrigger',
    components: {
      mainPanel: CommandsResultsMainPanel,
      asidePanel: CommandAsidePanel,
    },
    props: {
      mainPanel: commandsProps.mainPanel,
      asidePanel: {
        ...commandsProps.asidePanel,
        isRegistrationTrigger: true,
      },
    },
  },
  {
    path: '/commands/registrationtrigger/:id/details',
    components: {
      mainPanel: CommandsResultsMainPanel,
      asidePanel: CommandAsidePanel,
    },
    props: {
      mainPanel: commandsProps.mainPanel,
      asidePanel: route => ({
        ...commandsProps.asidePanel,
        itemId: route.params.id,
        isRegistrationTrigger: true,
      }),
    },
  },
  {
    path: '/commands/:id/details',
    meta: metaData,
    components: {
      mainPanel: CommandsResultsMainPanel,
      asidePanel: CommandAsidePanel,
    },
    props: {
      mainPanel: commandsProps.mainPanel,
      asidePanel: route => ({
        ...commandsProps.asidePanel,
        itemId: route.params.id,
      }),
    },
  },
  {
    path: '/commandresults',
    meta: metaData,
    components: {
      mainPanel: CommandsResultsMainPanel,
    },
    props: {
      mainPanel: {
        ...commandsProps.mainPanel,
        activeTab: 'commandresults',
      },
    },
  },
  {
    path: '/commandqueues',
    meta: metaData,
    components: {
      mainPanel: CommandsResultsMainPanel,
    },
    props: {
      mainPanel: {
        ...commandsProps.mainPanel,
        activeTab: 'commandqueues',
      },
    },
  },
  {
    path: '/commandqueue/:id/details',
    meta: {
      title: 'Back',
      returnPath: '/commandqueues',
    },
    components: {
      mainPanel: CommandQueueDetailMainPanel,
    },
  },
];
